import React from "react";
import "./RefreshButton.scss";
import BigLabel from "../../ui/BigLabel/BigLabel";

const RefreshButton = ({ onClick, children }) => {
  return (
    <div className="moderation-refresh-button">
      <BigLabel onClick={onClick}>{children}</BigLabel>
    </div>
  );
};

export default RefreshButton;
